import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { Button, FormGroup, Form, Input, Row, Col, Spinner } from "reactstrap";
import InputDatePickerMesAno from "components/Inputs/InputDatePickerMesAno";

// utils
import { showMessage, showMessageHtml } from "utils/message.js";
import { formateMesAno, formateDateByMesAno } from "utils/formats";
import { getSessionCookie } from 'utils/cookies';

// api
import dreelegiveis_api from 'api/dreelegiveis_api';
import DREElegiveisLista from './DREElegiveisLista';

export default function DREElegiveis() {

    var session = getSessionCookie();

    const { handleSubmit, register, errors, clearErrors, reset } = useForm({ mode: "onBlur" });
    const [showLoading, setshowLoading] = useState(false);

    const [startDate, setStartDate] = useState(formateDateByMesAno(session.mesAnoDefault));
    const [elegivelFile, setElegivelFile] = React.useState(null);

    //===================================================================================CHANGE ARQUIVO================================================================================================//
    const onChangeFileElegivel = async (event) => {
        const file = event.target.files[0];
        setElegivelFile(file);
        clearErrors("elegivelFile");
    };
    //=======================================================================================================================================================================================================//

    //===================================================================================SUBMIT ARQUIVO - API================================================================================================//
    const onSubmit = () => {
        setshowLoading(true)
        let mesAno = formateMesAno(startDate);

        var formData = new FormData();
        formData.append("file", elegivelFile);

        dreelegiveis_api.uploadDREElegiveis(mesAno.replace("/", "-"), formData).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                if (result.data?.message) {
                    showMessageHtml("Aviso", (<>
                        Arquivo Importado com Sucesso!<br /><br />
                        Porém os seguintes CustCodes não foram identificados na base do CadTIM_CSJ<br /><br />
                        <DREElegiveisLista items={result.data.items} />
                    </>), 'warning', null);
                } else {
                    showMessage("Aviso", "Arquivo importado com sucesso!", 'success', null);
                }
            }
            reset();
        });
    }
    //=======================================================================================================================================================================================================//

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className="content">
                <h5>Importação Elegíveis</h5>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col lg="2" md="4" sm="4">
                            <FormGroup>
                                <label required className="form-control-label">Mês/Ano *</label>
                                <InputDatePickerMesAno selected={startDate} onChange={(date) => setStartDate(date)} ></InputDatePickerMesAno>
                                {errors.startDate && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col lg="4" md="2" sm="6" className="mt-2">
                            <FormGroup>
                                <label>Arquivo *</label>
                                <Input
                                    type="file"
                                    label={"Arquivo *"}
                                    variant="outlined"
                                    name="elegivelFile"
                                    accept=".xlsx, .xls, .csv"
                                    InputLabelProps={{ shrink: true }}
                                    onChange={onChangeFileElegivel}
                                    innerRef={register({ required: true })}
                                />
                                {errors.elegivelFile && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>

                        <Col lg="2" md="2" sm="2" className="mt-2">
                            <Button color="success" type="submit"><i className="fas fa-save"></i>  Importar</Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        </>
    );
}

